import * as linkify from 'linkify-it';

export function formatRichTextToHTML(html: string, youtubeOrigin: string = '') {
  // note: order matters be careful

  // handle youtube video player
  const youtubeFormat = html.replace(
    /(?:\n|\n\r|^)http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?(?:&[\w\?‌​=]*)*(?:\n|\n\r|$)/gmi,
    `<div style="margin: 0 auto;width: 100%;text-align: center;padding: 20px 0;"><iframe id="ytplayer-$1" type="text/html" style="margin: 0 auto; max-width: 640px; width: 100%;" width="100%" height="360" src="https://www.youtube.com/embed/$1?autoplay=0&origin=${youtubeOrigin}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`
  );
  // handle vimeo video player
  const vimeoFormat = youtubeFormat.replace(
    /(?:\n|\n\r|^)http(?:s?):\/\/(?:www\.)?vimeo\.com\/(\d+)(?:\n|\n\r|$)/gmi,
    `<div style="margin: 0 auto; width: 100%; text-align: center; padding: 20px 0;"><iframe src="https://player.vimeo.com/video/$1?autoplay=0&loop=0&autopause=0" style="margin: 0 auto; max-width: 640px; width: 100%;" width="100%" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`
  );
  // handle images
  const imagesFormat = vimeoFormat.replace(
    /(?:\n|\n\r|^)(http(?:s?):\/\/[^ ]*\.(?:png|jpg|jpeg|gif|svg)[^\s]*)(?:\n|\n\r|$)/gmi,
    `<div style="margin: 0 auto; width: 100%; text-align: center; padding: 20px 0;"><img src="$1" style="margin: 0 auto; max-width: 640px; max-height: 360px; width: auto; height: auto;" width="auto" height="auto" /></div>`
  );
  const dateFormat = imagesFormat.replace(/\d{1,2}[.]\d{1,2}[.]\d{2,4}/gm, (match, index, value) => {
    const replaced = match.split('.').join('-');
    return replaced;
  });
  // transform bullets list container
  const bulletsFormat = dateFormat.replace(/(?:\n|\n\r|^)((?:[\*•] *(?:.*)(\n\r|\n|$))+)/gm, '<ul>\n\r$1</ul>');
  // transform list items
  const listItemsFormat = bulletsFormat.replace(/(?:\n|\n\r)(?:[\*•]|[0-9]+\.) *([^\n]*)/gm, '<li>$1</li>');
  // transform links
  const linksFormat = linkifyWrapURLs(listItemsFormat, true);
  // transform new line characters
  const newLinesFormat = linksFormat.replace(/(?:\n\r|\n)/gm, '<br />');
  // transform emails
  // const emailsFormat = linksFormat.replace(/([^"='])([a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*)/gmi, '$1<a href="mailto:$2">$2</a>')

  return newLinesFormat;
}

export function linkifyWrapURLs(text: string, isTargetBlank: boolean) {
  const linki = linkify();
  const links = linki.match(text);
  const target = (isTargetBlank === true || isTargetBlank == null) ? '_blank' : '';
  let textCopy = text;
  if (links) {
    // Replace each non-attribute link with wrapped link starting from the end of the content
    links.reverse().forEach((link) => {
      if (!isAttributeLink(text, link.index)) {
        textCopy = textCopy.substring(0, link.index) + '<a href="' + link.url + '" target="' + target + '">' + link.text + '</a>' + textCopy.substring(link.lastIndex, textCopy.length);
      }
    });
  }
  return textCopy;
}

/*
Determines if the URL is embedded as attribute, e.g. <iframe src="https://youtube.com?v=123"></iframe>
 */
function isAttributeLink(text, indexOfMatch) {
  if (isNaN(indexOfMatch)) {
    return false;
  }
  if (indexOfMatch < 2) {
    return false;
  }
  const prefix2Chars = text.substring(indexOfMatch - 2, indexOfMatch);
  if (prefix2Chars === '="') {
    return true;
  }
  return false;
}
